import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IonItem, IonLabel, IonList, IonListHeader, IonNote, IonSkeletonText } from '@ionic/react';
import { AttributeModel } from '../models/attribute.model';
import { attributePresenterFactory } from '../presenters/attribute.presenter';
import { EditableAttribute } from './editable-attribute.component';

interface AttributesProps {
  isPlanExported: boolean;
  attributes: AttributeModel[];
  isAttributesLoading: boolean;
  onAttributeValueChanged: (componentId: string, attributeId: string, newValue: any) => Promise<void>;
  buildingAddress?: string;
}

export const Attributes: FunctionComponent<AttributesProps> = ({
                                                                 isPlanExported,
                                                                 attributes,
                                                                 isAttributesLoading,
                                                                 onAttributeValueChanged,
                                                                 buildingAddress,
                                                               }) => {
  const { t } = useTranslation();

  return (
    <>
      { buildingAddress && (
        <IonLabel style={{ 
          fontSize: '10px',
          display: 'block',
          fontFamily: 'Open Sans, sans-serif',
          fontWeight: 400,
          lineHeight: '1',
          letterSpacing: '0.5px',
          color: '#165BE6',
          marginBottom: '5px',
          marginTop: '16px',
          marginLeft: '16px'
        }} color={ 'tertiary' }>
          { buildingAddress }
        </IonLabel>
      )}
      <IonList lines="full" inset role="list">
      <IonListHeader className={ 'ion-no-padding' }>{ t('plan.attributesView.attributeListLabel') }</IonListHeader>
      { isAttributesLoading
        ? [1, 2, 3].map((key) => (
          <IonItem key={ key } role="listitem">
            <IonLabel slot="start">
              <IonSkeletonText animated style={ { width: '95%' } }/>
            </IonLabel>
            <IonNote slot="end" style={ { width: '50%' } }>
              <IonSkeletonText animated/>
            </IonNote>
          </IonItem>
        ))
        : attributes
          .map((attribute) => attributePresenterFactory(attribute))
          .map((attribute, index) =>
            <EditableAttribute
              key={ `${ attribute.componentId }+${ attribute.id }` }
              isPlanExported={isPlanExported}
              attribute={ attribute }
              onAttributeValueChanged={ (newValue: any) =>
                onAttributeValueChanged(attribute.componentId, attribute.id, newValue)
              }
            />
          ) }
      </IonList>
    </>
  );
};
